import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorMaterialGraphRevisionFragment = { __typename: 'ConfiguratorMaterialRevision', id: string, legacyId: number, graphNode: any, material: { __typename: 'ConfiguratorMaterial', legacyId: number } };

export type ConfiguratorLatestMaterialGraphExtendedFragment = { __typename: 'ConfiguratorMaterial', id: string, legacyId: number, latestCyclesRevision?: { __typename: 'ConfiguratorMaterialRevision', id: string, legacyId: number, graphNode: any, material: { __typename: 'ConfiguratorMaterial', legacyId: number } } | null };

export type ConfiguratorMaterialRevisionsForMaterialGraphQueryVariables = Types.Exact<{
  legacyIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type ConfiguratorMaterialRevisionsForMaterialGraphQuery = { __typename: 'Query', configuratorMaterialRevisions: Array<{ __typename: 'ConfiguratorMaterialRevision', id: string, legacyId: number, graphNode: any, material: { __typename: 'ConfiguratorMaterial', legacyId: number } }> };

export type ConfiguratorLatestMaterialRevisionsForMaterialGraphQueryVariables = Types.Exact<{
  legacyIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type ConfiguratorLatestMaterialRevisionsForMaterialGraphQuery = { __typename: 'Query', configuratorMaterials: Array<{ __typename: 'ConfiguratorMaterial', id: string, legacyId: number, latestCyclesRevision?: { __typename: 'ConfiguratorMaterialRevision', id: string, legacyId: number, graphNode: any, material: { __typename: 'ConfiguratorMaterial', legacyId: number } } | null }> };

export const ConfiguratorMaterialGraphRevisionFragmentDoc = gql`
    fragment ConfiguratorMaterialGraphRevision on ConfiguratorMaterialRevision {
  id
  legacyId
  graphNode
  material {
    legacyId
  }
}
    `;
export const ConfiguratorLatestMaterialGraphExtendedFragmentDoc = gql`
    fragment ConfiguratorLatestMaterialGraphExtended on ConfiguratorMaterial {
  id
  legacyId
  latestCyclesRevision {
    ...ConfiguratorMaterialGraphRevision
  }
}
    `;
export const ConfiguratorMaterialRevisionsForMaterialGraphDocument = gql`
    query configuratorMaterialRevisionsForMaterialGraph($legacyIds: [Int!]) {
  configuratorMaterialRevisions(legacyIds: $legacyIds) {
    ...ConfiguratorMaterialGraphRevision
  }
}
    ${ConfiguratorMaterialGraphRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorMaterialRevisionsForMaterialGraphGQL extends Apollo.Query<ConfiguratorMaterialRevisionsForMaterialGraphQuery, ConfiguratorMaterialRevisionsForMaterialGraphQueryVariables> {
    override document = ConfiguratorMaterialRevisionsForMaterialGraphDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorLatestMaterialRevisionsForMaterialGraphDocument = gql`
    query configuratorLatestMaterialRevisionsForMaterialGraph($legacyIds: [Int!]) {
  configuratorMaterials(legacyIds: $legacyIds) {
    ...ConfiguratorLatestMaterialGraphExtended
  }
}
    ${ConfiguratorLatestMaterialGraphExtendedFragmentDoc}
${ConfiguratorMaterialGraphRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorLatestMaterialRevisionsForMaterialGraphGQL extends Apollo.Query<ConfiguratorLatestMaterialRevisionsForMaterialGraphQuery, ConfiguratorLatestMaterialRevisionsForMaterialGraphQueryVariables> {
    override document = ConfiguratorLatestMaterialRevisionsForMaterialGraphDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }